import { createApp } from 'vue';
import DkBot from './DkBot.vue';

document.addEventListener("DOMContentLoaded", () => {
    const botContainer = document.querySelector('[data-dk-bot]');

    if (botContainer) {
        const dkBot = createApp(DkBot, {
            dkBotContainerId: botContainer.id ?? `bot_${botContainer.dataset.dkBot}`,
            dkBot: botContainer.dataset.dkBot,
            dkBotName: botContainer.dataset.dkBotName ?? 'Botti',
            dkBotImageUrl: botContainer.dataset.dkBotImageUrl ?? process.env.BASE_URL + 'bot-avatar.png',
            //dkBotMsgBgColor: botContainer.dataset.dkBotMsgBgColor ?? '#eaf4e5;',
            dkBotGtmStartEvent: botContainer.dataset.dkBotGtmStartEvent ?? null, //'bot_started',
            dkBotGtmSubmitEvent: botContainer.dataset.dkBotGtmSubmitEvent ?? null, //'bot_contact',
        });

        /*dkBot.config.errorHandler = (err, instance, info) => {
            console.log('dkBot ERROR!', err,  instance, info);
        }*/

        dkBot.mount(botContainer);
    }
});
